import React, { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "./providers/auth";
import { styles } from "../modules/shared/styles";

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

const MainSection = lazy(() => import("../modules/main").then((m) => ({ default: m.MainSection })));
const GuideSection = lazy(() => import("../modules/guide").then((m) => ({ default: m.GuideSection })));
const ProductionSection = lazy(() => import("../modules/production").then((m) => ({ default: m.ProductionSection })));
const PointsSection = lazy(() => import("../modules/points").then((m) => ({ default: m.PointsSection })));
const DeliverySection = lazy(() => import("../modules/delivery").then((m) => ({ default: m.DeliverySection })));
const CenterSection = lazy(() => import("../modules/center").then((m) => ({ default: m.CenterSection })));
const WarehouseJbiSection = lazy(() => import("../modules/warehouse-jbi").then((m) => ({ default: m.WarehouseJbiSection })));
const WarehouseJbiMskSection = lazy(() => import("../modules/warehouse-jbi-msk").then((m) => ({ default: m.WarehouseJbiMskSection })));
const DeliveryNerudSection = lazy(() => import("../modules/delivery-nerud").then((m) => ({ default: m.DeliveryNerudSection })));
const DeliveryNerudNewSection = lazy(() => import("../modules/delivery-nerud-new").then((m) => ({ default: m.DeliveryNerudNewSection })));
const DeliveryDeckeSection = lazy(() => import("../modules/delivery-decke").then((m) => ({ default: m.DeliveryDeckeSection })));
const StorageNerudSection = lazy(() => import("../modules/storage-nerud").then((m) => ({ default: m.StorageNerudSection })));
const StorageBetonSection = lazy(() => import("../modules/storage-beton").then((m) => ({ default: m.StorageBetonSection })));
const MixersSection = lazy(() => import("../modules/mixers").then((m) => ({ default: m.MixersSection })));
const SpecialPointsSection = lazy(() => import("../modules/special-points").then((m) => ({ default: m.SpecialPointsSection })));
const DeliveryCostRulesTable = lazy(() => import("../modules/delivery-cost-rules").then((m) => ({ default: m.DeliveryCostRulesTable })));
const AnswersLogistiSection = lazy(() => import("../modules/answers-logisti").then((m) => ({ default: m.AnswersLogistiSection })));
const WarehouseStockSection = lazy(() => import("../modules/warehouse-stock").then((m) => ({ default: m.WarehouseStockSection })));
const ReferenceInfoPage = lazy(() => import("../modules/reference-info").then((m) => ({ default: m.ReferenceInfoPage })));
const WarehousesPage = lazy(() => import("../modules/warehouses").then((m) => ({ default: m.WarehousesPage })));
const AnalogSettingsPage = lazy(() => import("../modules/analog-settings/AnalogSettingsPage"));
const DeliveryPage = lazy(() => import("../modules/delivery-page").then((m) => ({ default: m.DeliveryPage })));
const CalculatorsSection = lazy(() => import("../modules/calculators").then((m) => ({ default: m.CalculatorsSection })));
const StoragesSection = lazy(() => import("../modules/storages").then((m) => ({ default: m.StoragesSection })));
const RegionsSection = lazy(() => import("../modules/regions").then((m) => ({ default: m.RegionsSection })));
const DeckePriceListSection = lazy(() => import("../modules/price-lists/DeckePriceListSection"));
const PriceListsSection = lazy(() => import("../modules/price-lists").then((m) => ({ default: m.PriceListsSection })));
const ApplicationDirectorySection = lazy(() => import("../modules/application-directory").then((m) => ({ default: m.ApplicationDirectorySection })));
const ImportantGroupsSection = lazy(() => import("../modules/important-groups").then((m) => ({ default: m.ImportantGroupsSection })));
const AeratedConcreteAndBrickSection = lazy(() => import("../modules/aerated-concrete-and-brick").then((m) => ({ default: m.AeratedConcreteAndBrickSection })));
const Load1StructuredSection = lazy(() => import("../modules/load1-structured").then((m) => ({ default: m.Load1StructuredSection })));
const MissingDataSection = lazy(() => import("../modules/missing-data").then((m) => ({ default: m.MissingDataSection })));
const TalanSection = lazy(() => import("../modules/talan").then((m) => ({ default: m.TalanSection })));
const MonolitSection = lazy(() => import("../modules/monolit").then((m) => ({ default: m.MonolitSection })));
const AllGroupsSection = lazy(() => import("../modules/all-groups").then((m) => ({ default: m.AllGroupsSection })));
const UnitsSection = lazy(() => import("../modules/units").then((m) => ({ default: m.UnitsSection })));
const WarningsSection = lazy(() => import("../modules/warnings").then((m) => ({ default: m.WarningsSection })));
const ProductMatchingSection = lazy(() => import("../modules/product-matching").then((m) => ({ default: m.ProductMatchingSection })));
const PriceListRecognitionSection = lazy(() => import("../modules/price-list-recognition").then((m) => ({ default: m.PriceListRecognitionSection })));
const AllSourcesSection = lazy(() => import("../modules/all-sources").then((m) => ({ default: m.AllSourcesSection })));
const AnalogsDensitySection = lazy(() => import("../modules/analogs-density").then((m) => ({ default: m.AnalogsDensitySection })));
const PopularNomenclatureSection = lazy(() => import("../modules/popular-nomenclature").then((m) => ({ default: m.PopularNomenclatureSection })));
const PromotionalProductsSection = lazy(() => import("../modules/promotional-products").then((m) => ({ default: m.PromotionalProductsSection })));
const DeletedFromLoad1Section = lazy(() => import("../modules/deleted-from-load1").then((m) => ({ default: m.DeletedFromLoad1Section })));
const PriceChangeLogsSection = lazy(() => import("../modules/price-change-logs").then((m) => ({ default: m.PriceChangeLogsSection })));
const AuditLogSection = lazy(() => import("../modules/audit-log").then((m) => ({ default: m.AuditLogSection })));
const LogistiAnswersSection = lazy(() => import("../modules/logisti-answers").then((m) => ({ default: m.LogistiAnswersSection })));
const AutoUpdatesSection = lazy(() => import("../modules/auto-updates").then((m) => ({ default: m.AutoUpdatesSection })));
const PriceSyncSection = lazy(() => import("../modules/pricesync").then((m) => ({ default: m.PriceSyncSection })));
const ParserSectionSection = lazy(() => import("../modules/parser").then((m) => ({ default: m.ParserSectionSection })));
const RightsSection = lazy(() => import("../modules/rights/RightsSection"));
const RoleConstructorSection = lazy(() => import("../modules/role-constructor").then((m) => ({ default: m.RoleConstructorSection })));
const DbManagementSection = lazy(() => import("../modules/db-management").then((m) => ({ default: m.DbManagementSection })));
const TasksLogistiPage = lazy(() => import("../modules/tasks-logisti").then((m) => ({ default: m.TasksLogistiPage })));

/**
 * Таблица маршрутов приложения. Все секции — lazy (code-splitting).
 * Оборачивается в <Suspense> на стороне App.
 */
export default function AppRoutes({
  handlePriceListsUpdate,
  priceLists,
  bitrixElements,
  canAccessItem,
}) {
  return (
                <Routes>
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <MainSection />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reference-info/*"
                    element={
                      <ReferenceInfoPage
                        onPriceListsUpdate={handlePriceListsUpdate}
                        bitrixElements={bitrixElements}
                      />
                    }
                  />
                  <Route
                    path="/analog-settings/*"
                    element={<AnalogSettingsPage />}
                  />
                  <Route
                    path="/warehouses/*"
                    element={
                      <WarehousesPage
                        priceLists={priceLists}
                        onPriceListsUpdate={handlePriceListsUpdate}
                        bitrixElements={bitrixElements}
                      />
                    }
                  />
                  <Route path="/delivery/*" element={<DeliveryPage />} />
                  <Route path="/guide" element={<GuideSection />} />
                  <Route path="/production" element={<ProductionSection />} />
                  <Route path="/points" element={<PointsSection />} />
                  <Route path="/calculators" element={<CalculatorsSection />} />
                  <Route path="/storages" element={<StoragesSection />} />
                  <Route path="/regions" element={<RegionsSection />} />
                  <Route
                    path="/price_lists"
                    element={
                      <PriceListsSection
                        onPriceListsUpdate={handlePriceListsUpdate}
                      />
                    }
                  />
                  <Route
                    path="/application_directory"
                    element={<ApplicationDirectorySection />}
                  />
                  <Route
                    path="/important_groups"
                    element={<ImportantGroupsSection />}
                  />
                  <Route
                    path="/warehouse_stock"
                    element={<WarehouseStockSection />}
                  />
                  <Route
                    path="/warehouse_jbi"
                    element={<WarehouseJbiSection />}
                  />
                  <Route
                    path="/warehouse_jbi_msk"
                    element={<WarehouseJbiMskSection />}
                  />
                  <Route
                    path="/storage_nerud"
                    element={<StorageNerudSection />}
                  />
                  <Route
                    path="/storage_beton"
                    element={<StorageBetonSection />}
                  />
                  <Route
                    path="/storage_beton_msk"
                    element={
                      <StorageBetonSection
                        apiEndpoint={`${PATH_TO_BACKEND}/api/adminka/storage_beton_msk`}
                        queryKey="storageBetonMskSection"
                        title="Прайс-лист бетонных материалов МСК"
                      />
                    }
                  />
                  <Route
                    path="/aerated_concrete_and_brick"
                    element={<AeratedConcreteAndBrickSection />}
                  />
                  <Route
                    path="/answers_logisti"
                    element={<AnswersLogistiSection />}
                  />
                  <Route path="/delivery_data" element={<DeliverySection />} />
                  <Route path="/center" element={<CenterSection />} />
                  <Route
                    path="/delivery_nerud"
                    element={<DeliveryNerudSection />}
                  />
                  <Route
                    path="/delivery_nerud_new"
                    element={<DeliveryNerudNewSection />}
                  />
                  <Route path="/mixers" element={<MixersSection />} />
                  <Route
                    path="/special_points"
                    element={<SpecialPointsSection />}
                  />
                  <Route
                    path="/delivery_cost_rules"
                    element={<DeliveryCostRulesTable />}
                  />
                  <Route
                    path="/delivery_cost_rules_msk"
                    element={
                      <DeliveryCostRulesTable
                        apiEndpoint="/api/adminka/delivery_cost_rules_msk"
                        queryKey="deliveryCostRulesMsk"
                        title="Доставка бетона МСК"
                      />
                    }
                  />
                  <Route
                    path="/load1_structured"
                    element={<Load1StructuredSection />}
                  />
                  <Route path="/talan" element={<TalanSection />} />
                  <Route path="/monolit" element={<MonolitSection />} />
                  <Route path="/all_groups" element={<AllGroupsSection />} />
                  <Route path="/units" element={<UnitsSection />} />
                  <Route path="/warnings" element={<WarningsSection />} />
                  <Route path="/all-sources" element={<AllSourcesSection />} />
                  <Route
                    path="/product-matching"
                    element={<ProductMatchingSection />}
                  />
                  <Route
                    path="/price-list-recognition"
                    element={<PriceListRecognitionSection />}
                  />
                  <Route
                    path="/rights"
                    element={
                      canAccessItem({
                        permissionKey: "page.rights",
                        access: "god",
                      }) ? (
                        <RightsSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/missing-data"
                    element={<MissingDataSection />}
                  />
                  <Route
                    path="/missing_data"
                    element={<MissingDataSection />}
                  />
                  <Route
                    path="/popular_nomenclature"
                    element={<PopularNomenclatureSection />}
                  />
                  <Route
                    path="/promotional_products_spb"
                    element={<PromotionalProductsSection region="СПБ" />}
                  />
                  <Route
                    path="/promotional_products_msk"
                    element={<PromotionalProductsSection region="МСК" />}
                  />
                  <Route
                    path="/promotional_products_krd"
                    element={<PromotionalProductsSection region="КРД" />}
                  />
                  <Route
                    path="/deleted_from_load1"
                    element={<DeletedFromLoad1Section />}
                  />
                  <Route
                    path="/price_change_logs"
                    element={<PriceChangeLogsSection />}
                  />
                  <Route
                    path="/audit-log"
                    element={
                      canAccessItem({
                        permissionKey: "page.audit-log",
                        access: "god",
                      }) ? (
                        <AuditLogSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/logisti-answers"
                    element={
                      canAccessItem({
                        permissionKey: "page.logisti-answers",
                        access: "god",
                      }) ? (
                        <LogistiAnswersSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/auto-updates"
                    element={
                      canAccessItem({
                        permissionKey: "page.auto-updates",
                        access: "god",
                      }) ? (
                        <AutoUpdatesSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/pricesync"
                    element={
                      canAccessItem({
                        permissionKey: "page.pricesync",
                        access: "god",
                      }) ? (
                        <PriceSyncSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/role-constructor"
                    element={
                      canAccessItem({
                        permissionKey: "page.role-constructor",
                        access: "god",
                      }) ? (
                        <RoleConstructorSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/db-management"
                    element={
                      canAccessItem({
                        permissionKey: "page.db-management",
                        access: "god",
                      }) ? (
                        <DbManagementSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/parser"
                    element={
                      canAccessItem({
                        permissionKey: "page.parser",
                        access: ["god", "СПБ", "МСК", "КРД", "ЛО"],
                      }) ? (
                        <ParserSectionSection />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="/tasks_logisti/*"
                    element={
                      canAccessItem({
                        permissionKey: "page.tasks_logisti",
                        access: ["god", "СПБ", "МСК", "КРД"],
                      }) ? (
                        <TasksLogistiPage />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <div
                        style={{
                          ...styles.contentWrapper,
                          backgroundColor: "var(--ui-bg)",
                        }}
                      >
                        <div style={{ padding: "20px", textAlign: "center" }}>
                          <p style={styles.error}>Неизвестный раздел</p>
                          <p>Переходим на главную страницу...</p>
                        </div>
                      </div>
                    }
                  />
                </Routes>
  );
}
